export interface FormResult {
  ok: boolean;
  message: string;
}

interface ParsedResponse {
  code?: string;
  message?: string;
  meta?: { message?: string; detail?: string };
}

/**
 * 统一表单提交逻辑：按表单约定提交 application/x-www-form-urlencoded，
 * 处理蜜罐反垃圾、服务端返回码与错误信息透出。
 */
export async function submitForm(form: HTMLFormElement): Promise<FormResult> {
  const formData = new FormData(form);

  const honeypot = String(formData.get("website_alt") ?? "").trim();
  if (honeypot) {
    // 命中蜜罐：不发送任何请求，返回与成功一致的通用反馈
    return { ok: true, message: "" };
  }
  formData.delete("website_alt");

  const body = new URLSearchParams();
  formData.forEach((value, key) => {
    if (typeof value === "string") {
      body.append(key, value);
    }
  });

  try {
    const response = await fetch(form.getAttribute("action") ?? "", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: body.toString(),
    });

    const responseText = await response.text();
    let parsed: ParsedResponse | null = null;
    try {
      parsed = JSON.parse(responseText) as ParsedResponse;
    } catch {
      parsed = null;
    }

    const code = parsed?.code;
    const serverMessage = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || "";
    const combined = `${serverMessage} ${responseText}`.toLowerCase();
    const isSpam = combined.includes("spam");

    if (!response.ok || code !== "OK" || isSpam) {
      return { ok: false, message: serverMessage || "提交未成功，请稍后重试。" };
    }
    return { ok: true, message: "" };
  } catch {
    return { ok: false, message: "网络异常，请检查网络连接后重试。" };
  }
}